import { render, staticRenderFns } from "./RedirectToMobilePost.vue?vue&type=template&id=57506578"
import script from "./RedirectToMobilePost.vue?vue&type=script&lang=js"
export * from "./RedirectToMobilePost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports